import Debug from 'debug';

const debug = Debug('songwhip/loadScript');

const getScriptNode = (src: string) =>
  document.querySelector(`script[src="${src}"]`) as HTMLScriptElement | null;

export const loadScript = ({ src, id }: { src: string; id?: string }) =>
  new Promise<void>((resolve) => {
    debug('load script', src);
    const prevScript = getScriptNode(src);

    if (prevScript) {
      debug('found prev script');
      const isLoaded = prevScript.dataset.loaded === 'true';

      if (isLoaded) {
        resolve();
        return;
      }

      prevScript.onload = () => {
        prevScript.onload = null;
        prevScript.dataset.loaded = 'true';
        resolve();
      };

      return;
    }

    debug('create new script');

    const script = document.createElement('script');
    if (id) script.id = id;
    script.src = src;
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      script.onload = null;
      script.dataset.loaded = 'true';
      resolve();
    };
  });

export const removeScript = (src: string) => {
  debug('remove script', src);
  const script = getScriptNode(src);
  if (!script) return;

  // check prevents error in hmr/dev mode
  if (document.body.contains(script)) {
    document.body.removeChild(script);
  }

  script.onload = null;
};
